import { reactive } from '@nuxtjs/composition-api'
import { IWebPushState } from './webPush.types'

export const webPuchState = reactive<IWebPushState>({
  init: false,
  permissionAsked: false,
  permissionTimeout: false,
  permissionGranted: false,
  permissionDenied: false,
  token: '',
})

export function webPuchStateReset() {
  webPuchState.init = false
  webPuchState.permissionAsked = false
  webPuchState.permissionTimeout = false
  webPuchState.permissionGranted = false
  webPuchState.permissionDenied = false
  webPuchState.token = ''
}
